export const CLIP_LEVEL = 250000;
export const ENVIZ_PN = 'D09SJZX';
